import { Inject, injectable } from 'inversify-props';
import { BaseAPIService } from './base-api.service';

const API_VERSION = process.env.VUE_APP_API_VERSION;
const REPORT_STUB_URL = `/api/v${API_VERSION}/Reports`;
const VETERINARIAN_BILLING_REPORT_URL = `${REPORT_STUB_URL}/VeterinarianBillingReport`;

export interface ReportService {
  getBillingReport(startDateUtc: string, endDateUtc: string): Promise<string>;
}

@injectable()
export class ReportService implements ReportService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async getBillingReport(
    startDateUtc: string,
    endDateUtc: string
  ): Promise<string> {
    const resp = await this._baseAPIService.client.get<string>(
      `${VETERINARIAN_BILLING_REPORT_URL}?startDateUtc=${startDateUtc}&endDateUtc=${endDateUtc}`
    );
    return resp.data;
  }
}
